import { render } from "./Disable2FAModal.vue?vue&type=template&id=500ca690"
import script from "./Disable2FAModal.vue?vue&type=script&lang=js"
export * from "./Disable2FAModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__